import { Component, JSX, Prop, h } from '@stencil/core'

import { DividerVariant } from './air-divider.types'

@Component({
  tag: 'air-divider',
  styleUrl: 'air-divider.scss',
  shadow: true,
})
export class AirDivider {
  /** Specifies divider style */
  @Prop() variant: DividerVariant = 'grey'

  render(): JSX.Element {
    const dividerClasses = {
      [`divider`]: true,
      [`divider-${this.variant}`]: true,
    }
    return <div class={dividerClasses}></div>
  }
}
